"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paletteOptions = void 0;
var component_2023_design_tokens_1 = require("@rentspree/component-2023-design-tokens");
exports.paletteOptions = {
    inversePrimary: {
        main: (0, component_2023_design_tokens_1.parseRSPToken)('rsp.sys.colors.inverse-primary.default'),
    },
};
//# sourceMappingURL=palette.js.map